import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gt_token", data.token);
      if (data.member_token) {
        localStorage.setItem("gt_member_token", data.member_token);
      }
      toast.success("Welcome back, Davon.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center px-6" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-md border border-zinc-800 bg-[#141414] p-8 md:p-10"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-10 bg-[#E5B43A] grid place-items-center">
            <Lock size={18} className="text-black" />
          </span>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Gain Time</div>
            <div className="font-display text-xl tracking-wider">Admin Access</div>
          </div>
        </div>
        <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="admin-email-input"
          className="w-full bg-[#0F0F0F] border border-zinc-800 px-4 py-3 mb-5 text-white focus:outline-none focus:border-[#E5B43A]"
        />
        <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2">Password</label>
        <div className="relative mb-8">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-password-input"
            className="w-full bg-[#0F0F0F] border border-zinc-800 px-4 py-3 pr-12 text-white focus:outline-none focus:border-[#E5B43A]"
          />
          <button
            type="button"
            onClick={() => setShowPassword((s) => !s)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            data-testid="toggle-password-visibility"
            className="absolute inset-y-0 right-0 px-3 flex items-center text-zinc-500 hover:text-[#E5B43A] transition-colors"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-submit-button"
          className="w-full bg-[#E5B43A] text-black font-bold uppercase tracking-widest px-6 py-4 text-sm hover:bg-white hover:text-[#0A0A0A] transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
